var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_769)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.211 16.9504C27.3501 18.0876 27.9892 19.6313 27.9892 21.2428C27.9892 22.8525 27.3501 24.3963 26.211 25.5353C25.0738 26.6744 23.53 27.3135 21.9204 27.3135C20.3107 27.3135 18.7669 26.6744 17.6297 25.5353C16.4907 24.3963 15.8516 22.8525 15.8516 21.2428C15.8516 19.6313 16.4907 18.0876 17.6297 16.9504C18.7669 15.8113 20.3107 15.1722 21.9204 15.1704C23.53 15.1722 25.0738 15.8113 26.211 16.9504ZM10.3907 16.9797C11.5096 18.115 12.1378 19.646 12.1378 21.2428C12.1378 22.8379 11.5096 24.3688 10.3907 25.506C9.27 26.6414 7.74822 27.2897 6.15319 27.3135C4.52886 27.3354 2.96497 26.7055 1.80761 25.5646C0.652082 24.4237 0.000152588 22.8672 0.000152588 21.2428C0.000152588 19.6167 0.652082 18.0601 1.80761 16.9192C2.96497 15.7784 4.52886 15.1484 6.15319 15.1722C7.74822 15.1942 9.27 15.8443 10.3907 16.9797ZM20.1056 7.58345C20.1056 9.19313 19.4646 10.7369 18.3274 11.8759C17.1902 13.0131 15.6465 13.6541 14.0368 13.6541C12.4271 13.6541 10.8833 13.0131 9.7443 11.8759C8.60708 10.7369 7.96797 9.19313 7.96797 7.58345C7.96797 5.97194 8.60708 4.42819 9.7443 3.28914C10.8833 2.15193 12.4271 1.51099 14.0368 1.51099C15.6465 1.51099 17.1902 2.15193 18.3274 3.28914C19.4646 4.42819 20.1056 5.97194 20.1056 7.58345Z",
    fill: "#F06A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 25.8208,
    fill: "white",
    transform: "translate(0 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsana);
export default __webpack_public_path__ + "static/media/asana.59e1487b2eaf1543a63fae70c0950cff.svg";
export { ForwardRef as ReactComponent };